import { EditOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';

import { EditDropdownFieldProps } from './EditDropdownField.props';
import { 
  StyledTypography,
  StyledSelectMenu
} from './EditDropdownField.styles';
import { isDropDownEmpty } from '../../../utils/common';
import {
  Button,
  ButtonColorProps,
  ButtonSizeProps,
  ButtonVariantProps
} from '../../atoms/Button';

export const EditDropdownField: React.FC<EditDropdownFieldProps> = ({
  isEditable,
  textColor = '',
  textFontSize = '',
  options,
  value,
  validate = false,
  optionalLabel,
  optionalLabelEnabled = false,
  errorMessageEnabled = true,
  onChange
}) => {
  const [isShown, setIsShown] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (value) {
      setTextValue(value);
    }
  }, [value]);

  const handleOnSubmit = () => {
    if (validate && isDropDownEmpty(textValue)) {
      return;
    }

    onChange(textValue);
    setIsEdit(false);
    setIsShown(false);
  };

  const handleCancel = () => {
    setTextValue(value);
    setIsEdit(false);
    setIsShown(false);
  };

  return (
    <Grid
      container 
      onMouseEnter={() => isEditable && setIsShown(true)}
      onMouseLeave={() => isEditable && setIsShown(false)}
      alignItems="center"
      display="flex"
      width="100%"
    >
      {isEdit ?
        <Grid
          size={{
            xs: 12,
            md: 8
          }}>
          <StyledSelectMenu
            id="edit-dropdown-field-select" 
            items={options}
            selectedValue={textValue} 
            onChange={(val) => setTextValue(val)}
            validate={validate && isDropDownEmpty(textValue)}
            optionalLabelEnabled={optionalLabelEnabled}
            optionalLabel={optionalLabel}
            helperTextEnabled={errorMessageEnabled}
          />
        </Grid>
        :
        <Grid>
          <StyledTypography
            color={textColor}
            fontSize={textFontSize}
          >
            {options?.find((obj) => obj.value === value)?.label || '-'}
          </StyledTypography>
        </Grid>
      }
      {isEdit &&
        <Grid>
          <Button variant={ButtonVariantProps.Primary} color={ButtonColorProps.Success} onClick={handleOnSubmit} size={ButtonSizeProps.Small} className="extra-small-button">
            Save
          </Button>
          <Button variant={ButtonVariantProps.Secondary} color={ButtonColorProps.Error} onClick={handleCancel} size={ButtonSizeProps.Small} className="extra-small-button">
            Cancel
          </Button>
        </Grid>
      }
      {isShown && !isEdit &&
        <Grid>
          <Button
            variant={ButtonVariantProps.Icon}
            size={ButtonSizeProps.Small}
            onClick={() => setIsEdit(true)}
          >
            <EditOutlined fontSize="small" color={ButtonColorProps.Warning} />
          </Button>
        </Grid>
      }
    </Grid>
  );
};
